module.exports = __webpack_public_path__ + "img/domestic-2007-communication.83b23d9c.jpg";